import Skeleton from 'global/StreamWidget/Skeleton';

import { StreamWrapper } from './guest.styled';

export default function StreamSkeleton() {
  return (
    <StreamWrapper>
      {[...new Array(5)].map((val) => (
        <Skeleton key={val} />
      ))}
    </StreamWrapper>
  );
}
